<app-toolbar>
    <button mat-stroked-button
            matTooltip="Refresh"
            class="toolbar-btn toolbar-btn--refresh"
            (click)="loadReports()">
        <mat-icon>refresh</mat-icon>
        <span>Refresh</span>
    </button>

    <div class="table-header">
        <!-- <app-dropdown [options]="filterOptions()" [activeValue]="activeFilter()" (changed)="filterRecords($event)" /> -->

        <div class="toolbar-search">
            <mat-form-field appearance="outline" class="search-field">
                <mat-label>Search</mat-label>
                <input matInput [formControl]="searchControl" placeholder="Type to search...">
                <mat-icon matSuffix>search</mat-icon>
            </mat-form-field>
        </div>
    </div>
</app-toolbar>

<div class="action-item-container">
    <div class="table-container">
        <div class="table-scroll-wrapper">
            <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8">
                <ng-container matColumnDef="select">
                    <th mat-header-cell *matHeaderCellDef>
                        <mat-checkbox (change)="$event ? masterToggle() : null"
                                      [checked]="isAllSelected()"
                                      [indeterminate]="selection.hasValue() && !isAllSelected()"
                                      aria-label="Select all items">
                        </mat-checkbox>
                    </th>
                    <td mat-cell *matCellDef="let row">
                        <mat-checkbox (click)="$event.stopPropagation()"
                                      (change)="selection.toggle(row)"
                                      [checked]="selection.isSelected(row)"
                                      [disabled]="row.status === 'Inactive'"
                                      aria-label="Select row">
                        </mat-checkbox>
                    </td>
                </ng-container>

                <ng-container matColumnDef="actionItemDescriptionEn">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                        Description
                        <app-table-column-filter class="column-filter" [class.active]="isActive('actionItemDescriptionEn')" (filterChange)="applyFilter($event, 'actionItemDescriptionEn')" />
                    </th>
                    <td mat-cell *matCellDef="let item" class="description-cell">
                        <a class="blue-link" [routerLink]="['edit', item.id]" [queryParamsHandling]="'merge'">
                            {{ item.actionItemDescriptionEn | stripHtml }}
                        </a>
                    </td>
                </ng-container>

                <ng-container matColumnDef="ID">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header appColumnResize>
                        ID
                        <app-table-column-filter class="column-filter" [class.active]="isActive('actionItemId')" (filterChange)="applyFilter($event, 'actionItemId')" />
                    </th>
                    <td mat-cell *matCellDef="let item">{{ item.actionItemId }}</td>
                </ng-container>
                <ng-container matColumnDef="actionItemOwner">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header appColumnResize>
                        Owner
                        <app-table-column-filter class="column-filter" [class.active]="isActive('actionItemOwner')" (filterChange)="applyFilter($event, 'actionItemOwner')" />
                    </th>
                    <td mat-cell *matCellDef="let item">{{ item.actionItemOwner }}</td>
                </ng-container>

                <ng-container matColumnDef="dueDate">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header appColumnResize>
                        Due Date
                        <app-table-column-filter class="column-filter" [class.active]="isActive('dueDate')" (filterChange)="applyFilter($event, 'dueDate')" />
                    </th>
                    <td mat-cell *matCellDef="let item">{{ item.dueDate | date: 'dd MMMM yyyy' }}</td>
                </ng-container>

                <ng-container matColumnDef="status">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header appColumnResize>
                        Status
                        <app-table-column-filter class="column-filter" [class.active]="isActive('status')" (filterChange)="applyFilter($event, 'status')" />
                    </th>
                    <td mat-cell *matCellDef="let item">{{ item.status }}</td>
                </ng-container>

                <ng-container matColumnDef="actionType">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header appColumnResize>
                        Action Type
                        <app-table-column-filter class="column-filter" [class.active]="isActive('actionType')" (filterChange)="applyFilter($event, 'actionType')" />
                    </th>
                    <td mat-cell *matCellDef="let item">{{ actionTypeLabelMap[item.actionType] }}</td>
                </ng-container>

                <ng-container matColumnDef="workScope">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header appColumnResize>
                        Work Scope
                        <app-table-column-filter class="column-filter" [class.active]="isActive('workScope')" (filterChange)="applyFilter($event, 'workScope')" />
                    </th>
                    <td mat-cell *matCellDef="let item">{{ workScopeLabelMap[item.workScope] }}</td>
                </ng-container>
                <ng-container matColumnDef="progress">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header appColumnResize>
                        Progress
                        <app-table-column-filter class="column-filter" [class.active]="isActive('progress')" (filterChange)="applyFilter($event, 'progress')" />
                    </th>
                    <td mat-cell *matCellDef="let item">{{ item.progress != null ? item.progress + '%' : '' }}</td>
                </ng-container>
                <ng-container matColumnDef="createdOn">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header appColumnResize>
                        Created On
                        <app-table-column-filter class="column-filter" [class.active]="isActive('createdOn')" (filterChange)="applyFilter($event, 'createdOn')" />
                    </th>
                    <td mat-cell *matCellDef="let item">{{ item.createdOn | date: 'dd MMMM yyyy HH:mm' }}</td>
                </ng-container>
                <ng-container matColumnDef="completedOn">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header appColumnResize>
                        Completed On
                        <app-table-column-filter class="column-filter" [class.active]="isActive('completedOn')" (filterChange)="applyFilter($event, 'completedOn')" />
                    </th>
                    <td mat-cell *matCellDef="let item">{{ item.completedOn | date: 'dd MMMM yyyy HH:mm' }}</td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"
                    (click)="selection.toggle(row)"
                    [class.selected]="selection.isSelected(row)"
                    [class.disabled]="row.status === 'Inactive'">
                </tr>

                <tr class="mat-row" *matNoDataRow>
                    <td class="mat-cell" [attr.colspan]="displayedColumns.length">
                        No data matching the filter "{{ searchControl.value }}".
                    </td>
                </tr>
            </table>
        </div>

        <div class="pagination-wrapper">
            <div class="custom-pagination">
                <!-- Page Size Selector -->
                <div class="page-size-selector">
                    <span class="page-size-label">Items per page:</span>
                    <select class="page-size-dropdown" [value]="pageSize" (change)="onPageSizeChange(+$any($event.target).value)">
                        <option *ngFor="let size of pageSizeOptions" [value]="size">{{ size }}</option>
                    </select>
                </div>

                <!-- Page Info -->
                <div class="page-info">
                    <span>{{ (currentPage - 1) * pageSize + 1 }} - {{ Math.min(currentPage * pageSize, totalFilterCount) }} of {{ totalFilterCount }}</span>
                </div>

                <!-- Pagination Controls -->
                <div class="pagination-controls">
                    <button
                        class="pagination-btn"
                        [disabled]="currentPage === 1 || totalFilterCount === 0"
                        (click)="goToFirstPage()"
                        title="First page">
                        <mat-icon>first_page</mat-icon>
                    </button>

                    <button
                        class="pagination-btn"
                        [disabled]="currentPage === 1 || totalFilterCount === 0"
                        (click)="goToPreviousPage()"
                        title="Previous page">
                        <mat-icon>chevron_left</mat-icon>
                    </button>

                    <!-- Page Numbers -->
                    <div class="page-numbers">
                        <ng-container *ngFor="let page of getPageNumbers()">
                            <button
                                *ngIf="page !== -1"
                                class="page-number-btn"
                                [class.active]="page === currentPage"
                                (click)="onPageChange(page)">
                                {{ page }}
                            </button>
                            <span *ngIf="page === -1" class="ellipsis">...</span>
                        </ng-container>
                    </div>

                    <button
                        class="pagination-btn"
                        [disabled]="currentPage >= totalPages || totalFilterCount === 0"
                        (click)="goToNextPage()"
                        title="Next page">
                        <mat-icon>chevron_right</mat-icon>
                    </button>

                    <button
                        class="pagination-btn"
                        [disabled]="currentPage >= totalPages || totalFilterCount === 0"
                        (click)="goToLastPage()"
                        title="Last page">
                        <mat-icon>last_page</mat-icon>
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
